import { useEffect, useState } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Servicehistorikk for en bil, nyeste først.
export function useVehicleServices(vehicleId) {
  const [state, setState] = useState({ services: [], loading: Boolean(vehicleId) });

  useEffect(() => {
    if (!vehicleId) {
      setState({ services: [], loading: false });
      return undefined;
    }
    return onSnapshot(
      query(collection(db, 'orgVehicles', vehicleId, 'services'), orderBy('date', 'desc')),
      snap => setState({ services: snap.docs.map(d => ({ id: d.id, ...d.data() })), loading: false }),
      () => setState({ services: [], loading: false }),
    );
  }, [vehicleId]);

  return state;
}
